import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { get, post } from "../../services/api/ApiClient";
import { MessageType, SourceType } from "./EngageGPTSlice";

export const fetchAnswer = createAsyncThunk<any, string, { state: RootState }>("chatAI/fetchAnswer", async (question, { getState, dispatch }) => {
  try {
    const requestBody = {
      question: question,
    };
    const response = await post("query", requestBody);
    const responseData = await response.json();
    console.log(responseData);
    // dispatch(setSelectedRowKeys([]));

    dispatch(setMessages({ message: responseData.answer, owner: "bot", sources: responseData.sources, processingTime: responseData.processing_time }));

    return responseData;
  } catch (err: any) {
    throw new Error(err.response?.data ?? "Failed to fetch file");
  }
});
// export const fetchSource = createAsyncThunk<any, string, { state: RootState }>("chatAI/fetchSource", async (sourceId, { getState, dispatch }) => {
//   try {
//     const response = await get(`source/${sourceId}`);
//     const responseData = await response.json();
//     console.log(responseData);
//     // dispatch(setSelectedRowKeys([]));

//     dispatch(setSourceContent(responseData));

//     return responseData;
//   } catch (err: any) {
//     throw new Error(err.response?.data ?? "Failed to fetch file");
//   }
// });
export const fetchSuggestQuestion = createAsyncThunk<any, any, { state: RootState }>("chatAI/fetchSuggestQuestion", async (question, { getState, dispatch }) => {
  try {
    const response = await get("suggested-questions");
    const responseData = await response.json();
    console.log(responseData);
    // dispatch(setSelectedRowKeys([]));

    return responseData;
  } catch (err: any) {
    throw new Error(err.response?.data ?? "Failed to fetch file");
  }
});

export const fetchAnswerStreaming = createAsyncThunk<any, string, { state: RootState }>("chatAI/fetchAnswerStreaming", async (question, { getState, dispatch }) => {
  dispatch(setMessages({ message: "", owner: "bot", sources: [], processingTime: 0 }));

  try {
    const requestBody = {
      // prompt: `Summarize the document in ${arg.wordCount} words`,
      question: question,
    };
    const response = await post("streaming-query", requestBody);
    // dispatch(setSelectedRowKeys([]));
    if (!response.ok || !response.body) {
      throw response.statusText;
    }
    const reader = response.body.getReader();
    while (true) {
      const { done, value } = await reader.read();

      if (done) {
        console.log(value);
        // setLoading(false);
        break;
      }
      // Convert the Uint8Array to a UTF-8 string
      const jsonString = new TextDecoder("utf-8").decode(value);

      // Split the jsonString into individual JSON-like objects
      const jsonObjects = jsonString.split("}{");

      // Loop through each JSON-like object
      jsonObjects.forEach(async (jsonString, index) => {
        const formattedJsonString = `{${jsonString}${index === jsonObjects.length - 1 ? "" : "}"}`.replaceAll(/{{/g, "{").replaceAll(/:": /g, '":');
        const jsonObject = JSON.parse(formattedJsonString);

        //want to update the last message inside the messages array with the new answer value
        if (jsonObject.messageType === "answer") {
          dispatch(updateCurrentRepliedMessage(jsonObject.message, "answer"));
        } else if (jsonObject.messageType === "end") {
          console.log(jsonObject);
          const resFilterSources = await post("document/sources", { filtered_sources: jsonObject.message.filtered_sources });
          const resFilterSourcesJson = await resFilterSources.json();
          console.log(resFilterSourcesJson.filtered_sources);
          dispatch(updateCurrentRepliedMessage({ ...jsonObject.message, filtered_sources: resFilterSourcesJson.filtered_sources }, "end", jsonObject.processingTime));
        }
      });
    }
  } catch (err: any) {
    console.log(err);
    throw new Error(err.response?.data ?? "Failed to fetch file");
  }
});
export const updateCurrentRepliedMessage = createAction("chatAI/updateCurrentRepliedMessage", (message, messageType, processingTime?) => {
  return { payload: { message: message, messageType: messageType, processingTime: processingTime } };
});
export const setMessages = createAction<MessageType>("chatAI/setMessages");
export const setSourceContent = createAction<SourceType>("chatAI/setSourceContent");
export const clearMessages = createAction("chatAI/clearMessages");
export const openSourceDetail = createAction("chatAI/openSourceDetail");
export const closeSourceDetail = createAction("chatAI/closeSourceDetail");
